import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../../core/QueryRequestProvider'
import {ProductModifier, initialFilter} from '../../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<ProductModifier>>
}
const ProductModifierCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const sort: 'ASC' | 'DESC' | undefined = useMemo(() => state.sort, [state])

  const sortColumn = () => {
    // avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting) {
      // enable sort asc
      updateState({order: id, sort: 'ASC', ...initialFilter})
      return
    }

    if (isSelectedForSorting && sort !== undefined) {
      if (sort === 'ASC') {
        // enable sort desc
        updateState({order: id, sort: 'DESC', ...initialFilter})
        return
      }

      // disable sort
      updateState({sort: undefined, order: undefined, ...initialFilter})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && sort !== undefined && `table-sort-${sort}`
      )}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {ProductModifierCustomHeader}
